import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const CCL = definePreset(Aura, {
  semantic: {
    transitionDuration: '0.3s',
    // transitionEasing: "cubic-bezier(0.4, 0, 0.2, 1)",
    // focusRing: {
    //   width: "2px",
    //   style: "solid",
    //   color: "{primary.color}",
    //   offset: "2px",
    //   shadow: "0 0 0 4px color-mix(in srgb, {primary.color}, transparent 80%)",
    // },
    disabledOpacity: '0.5',
    iconSize: '1.1rem',
    anchorGutter: '4px',
    primary: {
      50: '#e6f0ff',
      100: '#cce1ff',
      200: '#99c3ff',
      300: '#66a5ff',
      400: '#3387ff',
      500: '#0069ff',
      600: '#0047ab',
      700: '#003d99',
      800: '#003388',
      900: '#002966',
      950: '#001f55',
    },
    // secondary: {
    //   50: "#e6f7ed",
    //   100: "#ccefda",
    //   200: "#99dfb6",
    //   300: "#66cf91",
    //   400: "#33bf6d",
    //   500: "#00af48",
    //   600: "#00a651",
    //   700: "#008f47",
    //   800: "#007a3d",
    //   900: "#006533",
    //   950: "#005029",
    // },
    // tertiary: {
    //   50: "#fffef0",
    //   100: "#fffde0",
    //   200: "#fffbc2",
    //   300: "#fff9a3",
    //   400: "#fff785",
    //   500: "#fff566",
    //   600: "#f4d03f",
    //   700: "#e6c235",
    //   800: "#d9b42c",
    //   900: "#cba622",
    //   950: "#be9819",
    // },
    formField: {
      paddingX: '0.75rem',
      paddingY: '0.5rem',
      sm: {
        fontSize: '0.875rem',
        paddingX: '0.625rem',
        paddingY: '0.375rem',
      },
      lg: {
        fontSize: '1.125rem',
        paddingX: '0.875rem',
        paddingY: '0.625rem',
      },
      borderRadius: '{primitive.borderRadius.md}',
      focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none',
      },
      transitionDuration: '{semantic.transitionDuration}',
    },
    list: {
      padding: '0.25rem 0.25rem',
      gap: '2px',
      header: {
        padding: '0.5rem 1rem 0.25rem 1rem',
      },
      option: {
        padding: '0.5rem 0.75rem',
        borderRadius: '{primitive.borderRadius.sm}',
      },
      optionGroup: {
        padding: '0.5rem 0.75rem',
        fontWeight: '600',
      },
    },
    content: {
      borderRadius: '{primitive.borderRadius.md}',
    },
    mask: {
      transitionDuration: '0.15s',
    },
    navigation: {
      list: {
        padding: '0.25rem 0.25rem',
        gap: '2px',
      },
      item: {
        padding: '0.5rem 0.75rem',
        borderRadius: '{primitive.borderRadius.sm}',
        gap: '0.5rem',
      },
      submenuLabel: {
        padding: '0.5rem 0.75rem',
        fontWeight: '600',
      },
      submenuIcon: {
        size: '0.875rem',
      },
    },
    overlay: {
      select: {
        borderRadius: '{primitive.borderRadius.md}',
        shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
      },
      popover: {
        borderRadius: '{primitive.borderRadius.md}',
        padding: '0.75rem',
        shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
      },
      modal: {
        borderRadius: '{primitive.borderRadius.xl}',
        padding: '1.25rem',
        shadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
      },
      navigation: {
        shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
      },
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f8fafc',
          100: '#f1f5f9',
          200: '#e2e8f0',
          300: '#cbd5e1',
          400: '#94a3b8',
          500: '#64748b',
          600: '#475569',
          700: '#334155',
          800: '#1e293b',
          900: '#0f172a',
          950: '#020617',
        },
        primary: {
          color: '{primary.600}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.700}',
          activeColor: '{primary.800}',
        },
        // secondary: {
        //   color: "{secondary.600}",
        //   contrastColor: "#ffffff",
        //   hoverColor: "{secondary.700}",
        //   activeColor: "{secondary.800}",
        // },
        // tertiary: {
        //   color: "{tertiary.600}",
        //   contrastColor: "#000000",
        //   hoverColor: "{tertiary.700}",
        //   activeColor: "{tertiary.800}",
        // },
        highlight: {
          background: '{surface.0}',
          focusBackground: '{surface.50}',
          color: '{primary.800}',
          focusColor: '{primary.900}',
        },
        mask: {
          background: 'rgba(40, 72, 105, 0.4)',
          color: '{surface.200}',
        },
        formField: {
          background: '{surface.0}',
          disabledBackground: '{surface.100}',
          filledBackground: '{surface.50}',
          filledHoverBackground: '{surface.100}',
          filledFocusBackground: '{surface.50}',
          borderColor: 'color-mix(in srgb, {primary.color}, transparent 75%)',
          hoverBorderColor: 'color-mix(in srgb, {primary.color}, transparent 50%)',
          focusBorderColor: '{primary.color}',
          invalidBorderColor: '{red.400}',
          color: '#000000',
          disabledColor: '{surface.500}',
          placeholderColor: 'color-mix(in srgb, {text.color}, transparent 60%)',
          invalidPlaceholderColor: '{red.600}',
          floatLabelColor: 'color-mix(in srgb, {text.color}, transparent 60%)',
          floatLabelFocusColor: '{primary.600}',
          floatLabelActiveColor: 'color-mix(in srgb, {text.color}, transparent 60%)',
          floatLabelInvalidColor: '{form.field.invalid.placeholder.color}',
          iconColor: 'color-mix(in srgb, {text.color}, transparent 60%)',
          shadow: '0 0 0 0 transparent',
          // focusShadow: "0 0 0 3px color-mix(in srgb, {primary.color}, transparent 85%)",
        },
        text: {
          color: '#000000',
          hoverColor: '{primary.900}',
          mutedColor: '{surface.500}',
          hoverMutedColor: '{surface.600}',
        },
        content: {
          background: '{surface.0}',
          hoverBackground: '{surface.100}',
          borderColor: '{surface.200}',
          color: '{text.color}',
          hoverColor: '{text.hover.color}',
        },
        overlay: {
          select: {
            background: '{surface.0}',
            borderColor: '{surface.200}',
            color: '{text.color}',
          },
          popover: {
            background: '{surface.0}',
            borderColor: '{surface.200}',
            color: '{text.color}',
          },
          modal: {
            background: '{surface.0}',
            borderColor: '{surface.200}',
            color: '{text.color}',
          },
        },
        list: {
          option: {
            focusBackground: '{surface.100}',
            selectedBackground: '{highlight.background}',
            selectedFocusBackground: '{highlight.focus.background}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            selectedColor: '{highlight.color}',
            selectedFocusColor: '{highlight.focus.color}',
            icon: {
              color: '{surface.400}',
              focusColor: '{surface.500}',
            },
          },
          optionGroup: {
            background: 'transparent',
            color: '{text.muted.color}',
          },
        },
        navigation: {
          item: {
            focusBackground: '{surface.100}',
            activeBackground: '{surface.100}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            activeColor: '{text.hover.color}',
            icon: {
              color: '{surface.400}',
              focusColor: '{surface.500}',
              activeColor: '{surface.500}',
            },
          },
          submenuLabel: {
            background: 'transparent',
            color: '{text.muted.color}',
          },
          submenuIcon: {
            color: '{surface.400}',
            focusColor: '{surface.500}',
            activeColor: '{surface.500}',
          },
        },
      },
      dark: {
        surface: {
          0: '#ffffff',
          50: '#f8fafc',
          100: '#f1f5f9',
          200: '#e2e8f0',
          300: '#cbd5e1',
          400: '#94a3b8',
          500: '#64748b',
          600: '#475569',
          700: '#334155',
          800: '#1e293b',
          900: '#0f172a',
          950: '#020617',
        },
        primary: {
          color: '{primary.400}',
          contrastColor: '#000000',
          hoverColor: '{primary.300}',
          activeColor: '{primary.200}',
        },
        // secondary: {
        //   color: "{secondary.400}",
        //   contrastColor: "#000000",
        //   hoverColor: "{secondary.300}",
        //   activeColor: "{secondary.200}",
        // },
        // tertiary: {
        //   color: "{tertiary.400}",
        //   contrastColor: "#000000",
        //   hoverColor: "{tertiary.300}",
        //   activeColor: "{tertiary.200}",
        // },
        highlight: {
          background: 'color-mix(in srgb, {primary.400}, transparent 84%)',
          focusBackground: 'color-mix(in srgb, {primary.400}, transparent 76%)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
        mask: {
          background: 'rgba(0,0,0,0.6)',
          color: '{surface.200}',
        },
        formField: {
          background: '{surface.800}',
          disabledBackground: '{surface.700}',
          filledBackground: '{surface.800}',
          filledHoverBackground: '{surface.700}',
          filledFocusBackground: '{surface.800}',
          borderColor: '{surface.600}',
          hoverBorderColor: '{surface.500}',
          focusBorderColor: '{primary.color}',
          invalidBorderColor: '{red.400}',
          color: '#ffffff',
          disabledColor: '{surface.400}',
          placeholderColor: '{surface.400}',
          invalidPlaceholderColor: '{red.400}',
          floatLabelColor: '{surface.400}',
          floatLabelFocusColor: '{primary.color}',
          floatLabelActiveColor: '{surface.400}',
          floatLabelInvalidColor: '{red.400}',
          iconColor: '{surface.400}',
          shadow: '0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, 0.3)',
        },
        text: {
          color: '#ffffff',
          hoverColor: '{primary.300}',
          mutedColor: '{surface.400}',
          hoverMutedColor: '{surface.300}',
        },
        content: {
          background: '{surface.800}',
          hoverBackground: '{surface.700}',
          borderColor: '{surface.600}',
          color: '{text.color}',
          hoverColor: '{text.hover.color}',
        },
        overlay: {
          select: {
            background: '{surface.800}',
            borderColor: '{surface.600}',
            color: '{text.color}',
          },
          popover: {
            background: '{surface.800}',
            borderColor: '{surface.600}',
            color: '{text.color}',
          },
          modal: {
            background: '{surface.800}',
            borderColor: '{surface.600}',
            color: '{text.color}',
          },
        },
        list: {
          option: {
            focusBackground: '{surface.700}',
            selectedBackground: '{highlight.background}',
            selectedFocusBackground: '{highlight.focus.background}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            selectedColor: '{highlight.color}',
            selectedFocusColor: '{highlight.focus.color}',
            icon: {
              color: '{surface.400}',
              focusColor: '{surface.300}',
            },
          },
          optionGroup: {
            background: 'transparent',
            color: '{text.muted.color}',
          },
        },
        navigation: {
          item: {
            focusBackground: '{surface.700}',
            activeBackground: '{surface.700}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            activeColor: '{text.hover.color}',
            icon: {
              color: '{surface.400}',
              focusColor: '{surface.300}',
              activeColor: '{surface.300}',
            },
          },
          submenuLabel: {
            color: '{text.muted.color}',
          },
          submenuIcon: {
            color: '{surface.400}',
            focusColor: '{surface.300}',
            activeColor: '{surface.300}',
          },
        },
      },
    },
  },
  components: {
    button: {
      root: {
        sm: {
          fontSize: '0.75rem',
          paddingX: '0.5rem',
          paddingY: '0.25rem',
        },
        paddingX: '0.75rem',
        paddingY: '0.375rem',
      },
    },
    togglebutton: {
      root: {
        sm: {
          fontSize: '0.75rem',
          padding: '0.1rem 0.08rem',
        },
      },
    },
    inputtext: {
      root: {
        sm: {
          fontSize: '0.75rem',
          paddingX: '0.5rem',
          paddingY: '0.25rem',
        },
      },
    },
    select: {
      root: {
        sm: {
          fontSize: '0.75rem',
          paddingX: '0.5rem',
          paddingY: '0.25rem',
        },
      },
    },
    inputgroup: {
      addon: {
        padding: '0.25rem 0.5rem',
        fontSize: '0.75rem',
        minWidth: 'auto',
      },
    },
    fileupload: {
      root: {
        borderRadius: '{primitive.borderRadius.md}',
      },
      header: {
        padding: '0.75rem 1rem',
        gap: '0.5rem',
      },
      content: {
        padding: '1rem',
        gap: '0.75rem',
      },
      file: {
        padding: '0.75rem 1rem',
        gap: '0.5rem',
        info: {
          gap: '0.25rem',
        },
      },
      fileName: {
        fontSize: '0.875rem',
      },
      fileSize: {
        fontSize: '0.75rem',
      },
      fileList: {
        gap: '0.5rem',
      },
      progressbar: {
        height: '0.5rem',
      },
      basic: {
        gap: '0.5rem',
      },
    },
  },
});
